import { z } from 'zod';
/** Виды сессий удалённого доступа (§7.8). */
export const SESSION_KINDS = ['vnc', 'ssh', 'video_live', 'video_archive'];
export const sessionKindSchema = z.enum(SESSION_KINDS);
/**
 * Сессия в списке — для экрана «Активные сессии» (§5.1, задача 13)
 * и для истории.
 *
 * Имена пользователя и узла подставляются на чтении: администратор смотрит
 * на список, чтобы решить, чью сессию закрыть, и набор UUID для этого
 * бесполезен.
 */
export const sessionSchema = z.object({
    id: z.uuid(),
    kind: sessionKindSchema,
    userId: z.uuid(),
    userDisplayName: z.string().nullable(),
    nodeId: z.uuid().nullable(),
    nodeName: z.string().nullable(),
    siteId: z.uuid().nullable(),
    siteName: z.string().nullable(),
    startedAt: z.iso.datetime(),
    endedAt: z.iso.datetime().nullable(),
    clientIp: z.string().nullable(),
    bytesIn: z.number().int(),
    bytesOut: z.number().int(),
    endReason: z.string().nullable(),
});
export const sessionQuerySchema = z.object({
    /** Только работающие сейчас. По умолчанию — они же: чаще всего нужны они. */
    active: z
        .enum(['true', 'false'])
        .default('true')
        .transform((value) => value === 'true'),
    userId: z.uuid().optional(),
    nodeId: z.uuid().optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
    cursor: z.string().min(1).optional(),
});
/**
 * Почему сессия закончилась.
 *
 * Значения не перечисление в БД, а свободный текст (§7.8): набор причин
 * растёт вместе с диагностикой. Здесь — те, что платформа ставит сама,
 * и их человеческие названия для интерфейса.
 */
export const SessionEndReason = {
    CLIENT_CLOSED: 'client_closed',
    SERVER_CLOSED: 'server_closed',
    AGENT_OFFLINE: 'agent_offline',
    TERMINATED: 'terminated',
    GATEWAY_SHUTDOWN: 'gateway_shutdown',
    HANDSHAKE_FAILED: 'handshake_failed',
    TICKET_EXPIRED: 'ticket_expired',
    ERROR: 'error',
};
/** Причины закрытия — ключами словаря: подпись собирает браузер. */
export const SESSION_END_REASON_KEYS = {
    [SessionEndReason.CLIENT_CLOSED]: 'sessions.endReason.clientClosed',
    [SessionEndReason.SERVER_CLOSED]: 'sessions.endReason.serverClosed',
    [SessionEndReason.AGENT_OFFLINE]: 'sessions.endReason.agentOffline',
    [SessionEndReason.TERMINATED]: 'sessions.endReason.terminated',
    [SessionEndReason.GATEWAY_SHUTDOWN]: 'sessions.endReason.gatewayShutdown',
    [SessionEndReason.HANDSHAKE_FAILED]: 'sessions.endReason.handshakeFailed',
    [SessionEndReason.TICKET_EXPIRED]: 'sessions.endReason.ticketExpired',
    [SessionEndReason.ERROR]: 'sessions.endReason.error',
};
/**
 * Ключ подписи причины закрытия. Незнакомая причина возвращается как есть —
 * это строка из базы, и показать её лучше, чем спрятать.
 */
export function sessionEndReasonKey(reason) {
    if (reason === null) {
        return null;
    }
    return SESSION_END_REASON_KEYS[reason] ?? reason;
}
//# sourceMappingURL=sessions.js.map